import * as THREE from 'three';
import { EngineLoop } from './loop';

export class DebugOverlay {
  private container: HTMLElement | null;
  private fpsEl: HTMLElement | null;
  private callsEl: HTMLElement | null;
  private trisEl: HTMLElement | null;
  private geoEl: HTMLElement | null;
  private texEl: HTMLElement | null;
  private resEl: HTMLElement | null;
  private isEnabled: boolean = false;
  private lastUpdate: number = 0;

  constructor() {
    this.container = document.getElementById('debug-overlay');
    this.fpsEl = document.getElementById('debug-fps');
    this.callsEl = document.getElementById('debug-drawcalls');
    this.trisEl = document.getElementById('debug-triangles');
    this.geoEl = document.getElementById('debug-geometries');
    this.texEl = document.getElementById('debug-textures');
    this.resEl = document.getElementById('debug-res');

    const params = new URLSearchParams(window.location.search);
    if (params.get('debug') === '1') {
      this.isEnabled = true;
      this.container?.classList.remove('hidden');
    }
  }

  public update(renderer: THREE.WebGLRenderer, loop: EngineLoop): void {
    if (!this.isEnabled) return;

    const now = performance.now();
    if (now - this.lastUpdate < 250) return; // Update 4 times per second
    this.lastUpdate = now;

    if (this.fpsEl) {
      this.fpsEl.innerText = `FPS: ${loop.fps} (${loop.frameTimeMs} ms)`;
    }
    if (this.callsEl) {
      this.callsEl.innerText = `Draw calls: ${renderer.info.render.calls}`;
    }
    if (this.trisEl) {
      this.trisEl.innerText = `Triangles: ${renderer.info.render.triangles.toLocaleString()}`;
    }
    if (this.geoEl) {
      this.geoEl.innerText = `Geometries: ${renderer.info.memory.geometries}`;
    }
    if (this.texEl) {
      this.texEl.innerText = `Textures: ${renderer.info.memory.textures}`;
    }
    if (this.resEl) {
      this.resEl.innerText = `Resolution: ${renderer.domElement.width}x${renderer.domElement.height} (${window.devicePixelRatio.toFixed(1)} DPR)`;
    }
  }
}
